/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetCompressorScheduleForecastRequest = {
  /**
   * Only return steps since the given time
   */
  since: Date;
  /**
   * Only return steps until the given time
   */
  until: Date;
  agentId: string;
};

/** @internal */
export type GetCompressorScheduleForecastRequest$Outbound = {
  since: string;
  until: string;
  agent_id: string;
};

/** @internal */
export const GetCompressorScheduleForecastRequest$outboundSchema: z.ZodType<
  GetCompressorScheduleForecastRequest$Outbound,
  z.ZodTypeDef,
  GetCompressorScheduleForecastRequest
> = z.object({
  since: z.date().transform(v => v.toISOString()),
  until: z.date().transform(v => v.toISOString()),
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function getCompressorScheduleForecastRequestToJSON(
  getCompressorScheduleForecastRequest: GetCompressorScheduleForecastRequest,
): string {
  return JSON.stringify(
    GetCompressorScheduleForecastRequest$outboundSchema.parse(
      getCompressorScheduleForecastRequest,
    ),
  );
}
